import { render } from "./AddressBook.vue?vue&type=template&id=bcd9d51a"
import script from "./AddressBook.vue?vue&type=script&lang=js"
export * from "./AddressBook.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/dashboard/AddressBook.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bcd9d51a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bcd9d51a', __exports__)) {
    console.log('reload')
    api.reload('bcd9d51a', __exports__)
  }
  
  module.hot.accept("./AddressBook.vue?vue&type=template&id=bcd9d51a", () => {
    console.log('re-render')
    api.rerender('bcd9d51a', render)
  })

}


export default __exports__